import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { POSTCOMPARATIVEANALYSISYOY } from '../common/constants/labels';
import { ApiService } from '../common/services/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ComparativeAnalyticsService {
  getConsolidateComparativeAnalysisYearOfYearURL = environment.APISETTINGS + POSTCOMPARATIVEANALYSISYOY;

  constructor(private service: ApiService) { }

  public getComparativeAnalysisYearOfYearData(filterParameter): Observable<any> {
    return this.service.post(this.getConsolidateComparativeAnalysisYearOfYearURL, filterParameter);
  }
}
